import { render, staticRenderFns } from "./productAttrList.vue?vue&type=template&id=65da2c26&scoped=true&"
import script from "./productAttrList.vue?vue&type=script&lang=js&"
export * from "./productAttrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da2c26",
  null
  
)

export default component.exports